module.exports = __webpack_public_path__ + "img/epr-price_small@2x.74ccfbeb.webp";